"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mixins_1 = require("../../theme/mixins");

exports.datePickerContainerStyles = {
  datePicker: {
    width: 274
  }
};

exports.datePickerHeadStyles = function (_a) {
  var toneValueBase = _a.toneValueBase;
  return {
    head: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: 16
    },
    headMonth: {
      textTransform: 'capitalize'
    },
    headControls: {
      display: 'flex',
      justifyContent: 'space-between',
      width: 16 * 3,
      marginRight: 5,
      height: 16,
      '& button': {
        background: 'transparent',
        height: 16,
        width: 16,
        padding: 0,
        margin: 0,
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        '&:disabled': {
          cursor: 'default',
          opacity: toneValueBase
        }
      }
    }
  };
};

exports.datePickerBodyStyles = {
  body: {
    paddingTop: 16,
    '& table': {
      borderSpacing: 8,
      marginLeft: -8,
      marginTop: -8,
      marginBottom: -8
    },
    '& td': {
      textAlign: 'center'
    },
    '& thead td': {
      cursor: 'default',
      textTransform: 'capitalize'
    }
  }
};
exports.controlMods = ['hover', 'focus', 'active', 'selected'];

exports.datePickerDayStyles = function (_a) {
  var toneValueBase = _a.toneValueBase,
      colorBorder = _a.colorBorder,
      colorPrimary = _a.colorPrimary;
  return {
    day: {
      '& button': {
        cursor: 'pointer',
        background: 'transparent',
        width: 30,
        height: 30,
        textAlign: 'center',
        padding: 0,
        borderRadius: 2,
        borderWidth: 2,
        borderColor: 'transparent',
        borderStyle: 'solid',
        outline: 'none',
        '&:not(:disabled)': {
          '&:hover, &$hover': {
            borderColor: mixins_1.calculateBorderColor(colorBorder.hover)
          },
          '&:focus, &$focus': {
            borderColor: mixins_1.calculateBorderColor(colorBorder.focus)
          },
          '&:active, &$active': {
            borderColor: mixins_1.calculateBorderColor(colorBorder.active),
            shadow: 'none'
          },
          '&$selected': {
            borderColor: colorPrimary.normal
          }
        },
        '&:disabled': {
          cursor: 'default',
          opacity: toneValueBase
        }
      }
    },
    hover: {},
    focus: {},
    active: {},
    selected: {}
  };
};